import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, Button, CardBody, Card, Breadcrumb, BreadcrumbItem, Col, Row, Container } from "reactstrap";
import { Link } from "react-router-dom";
import UserPanelMenu from "./../../components/user/UserPanelMenu";
import 'react-day-picker/lib/style.css';

import { API_URL, options } from "../../config/Config";

// import Pagination from '../../components/passenger/Pagination';
import TicketItem from '../../components/user/TicketItem';
import axios from 'axios';
import MUIDataTable from "mui-datatables";
// import TicketPassengers from '../search/TicketPassengers';
import { ALL_BUS_STATIONS } from "../../containers/bus/BusConfig";
import { airports } from "../../redux/utils/airports";
import BusTicketitem from "../../components/user/BusTicketitem";


class UserTicketList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            fields: {
                type: "1",
                origin: null,
                destination: null,
                departureDate: null,
                origin2: null,
                destination2: null,
                departureDate2: null,
                adult: 1,
                child: 0,
                infant: 0,
                preferences: 0,
            },
            isIran: false,
            modal: false,
            tikects: [],
            sortBy: null,
            columnDefs:
                [
                    {
                        name: "No.",
                        options: {
                            filter: false,
                            sort: false,
                        }
                    },
                    {
                        name: "From",
                        options: {
                            filter: true,
                            sort: true,
                        }
                    },
                    {
                        name: "To",
                        options: {
                            filter: true,
                            sort: true,
                        }
                    },
                    {
                        name: "Order Date",
                        options: {
                            filter: true,
                            sort: true,
                        }
                    },
                    {
                        name: "Details",
                        options: {
                            filter: false,
                            sort: false,
                        }
                    },
                    {
                        name: "PDF",
                        options: {
                            filter: false,
                            sort: false,
                        }
                    },
                ],
            rowData: [],
        };
        this.toggle = this.toggle.bind(this);
        this.Editpassenger = this.Editpassenger.bind(this);

    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }


    Editpassenger() {
        this.setState({
            modal: !this.state.modal
        });
    }
    async componentDidMount() {
        const access_token = localStorage.getItem('api_token');
        const options = {
            method: 'GET',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            url: API_URL + 'user-ticket?api_token=' + access_token,
        };
        let response = await axios(options);
        console.log(response);
        if (response.status === 200) {
            console.log(response);
            const tikects = response.data.data.data;
            const rowData = [];
            tikects.map((ticket, i) => {
                if (ticket.type === "airplane") {
                    rowData.push([
                        <span className='span-type-ticket' >{i + 1}<i className="fas fa-plane"></i></span>, airports.filter(item => item.iata === ticket.AirplaneTicket.departureAirport)[0].city, airports.filter(item => item.iata === ticket.AirplaneTicket.arrivalAirport)[0].city, ticket.created_at.slice(0, 10), <Button onClick={this.HandelDetail.bind(this, ticket)} >View</Button>, <Button onClick={this.DownloadPdf.bind(this, ticket.id, 'airplane')} >Download</Button>
                    ])
                }
                if (ticket.type === "bus") {
                    rowData.push([
                        <span className='span-type-ticket' >{i + 1}<i className="fas fa-bus"></i></span>, ALL_BUS_STATIONS.filter(i => i.value === ticket.BusTicket.orginStationCode)[0].label, ALL_BUS_STATIONS.filter(i => i.value === ticket.BusTicket.destinationStationCode)[0].label, ticket.BusTicket.created_at.slice(0, 10), <Button onClick={this.HandelDetail.bind(this, ticket)} >View</Button>, <Button onClick={this.DownloadPdf.bind(this, ticket.id, 'bus')} >Download</Button>
                    ])
                }
                return true;
            }
            )
            this.setState({ rowData })
        }
    }

    async HandelDetail(e) {
        await this.setState({ tikects: e, modal: !this.state.modal })
    }
    async DownloadPdf(e, a) {
        console.log(e);
        window.location.replace(API_URL + 'get-ticket/' + e + '?ticket_type=' + a);
    }



    render() {
        // const { fields } = this.state;

        return (
            <div className="pt-5 mt-5">
                <Container>
                    <Breadcrumb className='w-100 white rounded mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">User Control panel</Link></BreadcrumbItem>
                        <BreadcrumbItem active> Dashboard</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12'>
                            <UserPanelMenu activeElement="3" />
                        </Col>
                        <Col md='9' sm='12'>
                            <div className="panel panel-default white">
                                <div className="portlet-title">
                                    <h4 className="user-panel-heading">My Tickets</h4>
                                    <div className="user-panel-content">
                                        <div className="passengers-results" >
                                            <Card>
                                                <CardBody>
                                                    {/* <h5 className="inner-passenger-title" > Search Ticket By</h5> */}
                                                    {/* <Form> */}
                                                    {/* <Row className='mt-3 md-5 rtl'>
                                                        <Col md='4' sm='12'>
                                                            <div className='sort-ticket-but' >
                                                                <Button outline color="secondary" className={(this.state.sortBy === "time") ? "activeSort" : "inactiveSort"} >
                                                                    <i className={(this.state.sortBy === "time" && this.state.sortASC) ? "fa fa-sort-amount-asc" : "fa fa-sort-amount-desc"} /> Flight time
                                                            </Button>
                                                            </div>
                                                        </Col>
                                                        <Col md='4' sm='12'>
                                                            <div className='Ticket-first-date'>
                                                                <span>
                                                                    From :
                                                            </span>
                                                                <DayPickerInput
                                                                    placeholder="Departure day"
                                                                // selectedDays={fields.departureDate2}
                                                                // onDayChange={this.handleDayChange2.bind(this)}
                                                                />

                                                            </div>
                                                        </Col>
                                                        <Col md='4' sm='12'>
                                                            <div className="ticket-second-date">
                                                                <span>
                                                                    To :
                                                            </span>
                                                                <DayPickerInput
                                                                    placeholder="Arrival Day"
                                                                // selectedDays={fields.departureDate2}
                                                                // onDayChange={this.handleDayChange2.bind(this)}
                                                                />

                                                            </div>
                                                        </Col>
                                                    </Row> */}
                                                    {/* <Row>
                                                        <Col md='12' sm='12'>
                                                            <Button color="danger" type="submit" style={{ marginBottom: '1rem' }}><i className="fas fa-search"></i>Search</Button>
                                                        </Col>
                                                    </Row> */}
                                                    {/* </Form> */}
                                                </CardBody>
                                            </Card>
                                            {/* <div className="pageinitation">
                                                <Pagination />
                                            </div> */}
                                            {/* {console.log(this.state.tikects)} */}


                                            {/* {this.state.tikects !== [] && this.state.tikects.map((tikect, i) => {
                                                return (
                                                    <TicketItem key={i}
                                                        tikect={tikect}
                                                    />
                                                )
                                            })
                                            } */}

                                            <MUIDataTable
                                                data={this.state.rowData}
                                                columns={this.state.columnDefs}
                                                options={options}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Modal isOpen={this.state.modal} toggle={this.Editpassenger} className=" edit-modal">
                    <ModalHeader toggle={this.Editpassenger}>View Details</ModalHeader>
                    <ModalBody>
                        {this.state.tikects.type === 'airplane' &&
                            <TicketItem
                                tikect={this.state.tikects}
                            />
                        }
                        {this.state.tikects.type === 'bus' &&
                            // 'bus'
                            <BusTicketitem
                                tikect={this.state.tikects}
                            />
                        }
                    </ModalBody>

                </Modal>
            </div>
        );
    }
}
// const mapStateToProps = (api_token) => {
//     return {
//         api_token: api_token,
//     }
// };
// export default connect(mapStateToProps, null)(UserCartsList)
export default UserTicketList;


// WEBPACK FOOTER //
// ./src/containers/user/UserTicketList.jsx